var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBankInfo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 35,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.833 4.333L3.166 11v2.667h25.333V11L15.833 4.333zm6 12v9.334h4v-9.334h-4zm-18.667 16h25.333v-4H3.166v4zm10.667-16v9.334h4v-9.334h-4zm-8 0v9.334h4v-9.334h-4z",
    fill: "#3A3F60"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M43.5 9.5a9.5 9.5 0 11-19 0 9.5 9.5 0 0119 0z",
    fill: "#FFAA2A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M35.19 5.788c0 .075-.027.14-.084.196a.269.269 0 01-.196.084h-1.82a.269.269 0 01-.196-.084.269.269 0 01-.084-.196V4.486c0-.075.029-.14.084-.196a.269.269 0 01.197-.084h1.82c.074 0 .14.028.195.084a.269.269 0 01.084.196v1.302zm-.055 8.932c0 .075-.029.14-.084.196a.269.269 0 01-.197.084h-1.707a.269.269 0 01-.197-.084.269.269 0 01-.084-.196V7.258c0-.075.029-.14.084-.196a.269.269 0 01.197-.084h1.708c.074 0 .14.028.196.084a.269.269 0 01.084.196v7.462z",
    fill: "#fff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBankInfo);
export default __webpack_public_path__ + "static/media/bank-info.d19eb174.svg";
export { ForwardRef as ReactComponent };